!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.ta = t());
}(this, function () {
  "use strict";

  return [{
    locale: "ta",
    pluralRuleFunction: function (e, t) {
      return t ? "other" : 1 == e ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "ஆண்டு",
        relative: {
          0: "இந்த ஆண்டு",
          1: "அடுத்த ஆண்டு",
          "-1": "கடந்த ஆண்டு"
        },
        relativeTime: {
          future: {
            one: "{0} ஆண்டில்",
            other: "{0} ஆண்டுகளில்"
          },
          past: {
            one: "{0} ஆண்டிற்கு முன்",
            other: "{0} ஆண்டுகளுக்கு முன்"
          }
        }
      },
      "year-short": {
        displayName: "ஆண்டு",
        relative: {
          0: "இந்த ஆண்டு",
          1: "அடுத்த ஆண்டு",
          "-1": "கடந்த ஆண்டு"
        },
        relativeTime: {
          future: {
            one: "{0} ஆண்டில்",
            other: "{0} ஆண்டுகளில்"
          },
          past: {
            one: "{0} ஆண்டிற்கு முன்",
            other: "{0} ஆண்டுகளுக்கு முன்"
          }
        }
      },
      month: {
        displayName: "மாதம்",
        relative: {
          0: "இந்த மாதம்",
          1: "அடுத்த மாதம்",
          "-1": "கடந்த மாதம்"
        },
        relativeTime: {
          future: {
            one: "{0} மாதத்தில்",
            other: "{0} மாதங்களில்"
          },
          past: {
            one: "{0} மாதத்துக்கு முன்",
            other: "{0} மாதங்களுக்கு முன்"
          }
        }
      },
      "month-short": {
        displayName: "மாத.",
        relative: {
          0: "இந்த மாதம்",
          1: "அடுத்த மாதம்",
          "-1": "கடந்த மாதம்"
        },
        relativeTime: {
          future: {
            one: "{0} மாத.",
            other: "{0} மாத."
          },
          past: {
            one: "{0} மாத. முன்",
            other: "{0} மாத. முன்"
          }
        }
      },
      day: {
        displayName: "நாள்",
        relative: {
          0: "இன்று",
          1: "நாளை",
          2: "நாளை மறுநாள்",
          "-2": "நேற்று முன் தினம்",
          "-1": "நேற்று"
        },
        relativeTime: {
          future: {
            one: "{0} நாளில்",
            other: "{0} நாட்களில்"
          },
          past: {
            one: "{0} நாளுக்கு முன்",
            other: "{0} நாட்களுக்கு முன்"
          }
        }
      },
      "day-short": {
        displayName: "நாள்",
        relative: {
          0: "இன்று",
          1: "நாளை",
          2: "நாளை மறுநாள்",
          "-2": "நேற்று முன் தினம்",
          "-1": "நேற்று"
        },
        relativeTime: {
          future: {
            one: "{0} நாளில்",
            other: "{0} நாட்களில்"
          },
          past: {
            one: "{0} நாளுக்கு முன்",
            other: "{0} நாட்களுக்கு முன்"
          }
        }
      },
      hour: {
        displayName: "மணி",
        relative: {
          0: "இந்த ஒரு மணிநேரத்தில்"
        },
        relativeTime: {
          future: {
            one: "{0} மணிநேரத்தில்",
            other: "{0} மணிநேரத்தில்"
          },
          past: {
            one: "{0} மணிநேரம் முன்",
            other: "{0} மணிநேரம் முன்"
          }
        }
      },
      "hour-short": {
        displayName: "மணி.",
        relative: {
          0: "இந்த ஒரு மணிநேரத்தில்"
        },
        relativeTime: {
          future: {
            one: "{0} மணி.",
            other: "{0} மணி."
          },
          past: {
            one: "{0} மணி. முன்",
            other: "{0} மணி. முன்"
          }
        }
      },
      minute: {
        displayName: "நிமிடம்",
        relative: {
          0: "இந்த ஒரு நிமிடத்தில்"
        },
        relativeTime: {
          future: {
            one: "{0} நிமிடத்தில்",
            other: "{0} நிமிடங்களில்"
          },
          past: {
            one: "{0} நிமிடத்திற்கு முன்",
            other: "{0} நிமிடங்களுக்கு முன்"
          }
        }
      },
      "minute-short": {
        displayName: "நிமி.",
        relative: {
          0: "இந்த ஒரு நிமிடத்தில்"
        },
        relativeTime: {
          future: {
            one: "{0} நிமி.",
            other: "{0} நிமி."
          },
          past: {
            one: "{0} நிமி. முன்",
            other: "{0} நிமி. முன்"
          }
        }
      },
      second: {
        displayName: "விநாடி",
        relative: {
          0: "இப்போது"
        },
        relativeTime: {
          future: {
            one: "{0} விநாடியில்",
            other: "{0} விநாடிகளில்"
          },
          past: {
            one: "{0} விநாடிக்கு முன்",
            other: "{0} விநாடிகளுக்கு முன்"
          }
        }
      },
      "second-short": {
        displayName: "விநா.",
        relative: {
          0: "இப்போது"
        },
        relativeTime: {
          future: {
            one: "{0} விநா.",
            other: "{0} விநா."
          },
          past: {
            one: "{0} விநா. முன்",
            other: "{0} விநா. முன்"
          }
        }
      }
    }
  }, {
    locale: "ta-LK",
    parentLocale: "ta"
  }, {
    locale: "ta-MY",
    parentLocale: "ta"
  }, {
    locale: "ta-SG",
    parentLocale: "ta"
  }];
});